import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService } from 'app/model/linkedservice/azure-data-lake-store-gen2-cosmos-structured-stream.linkedservice';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { FileTypeDataset } from './file-type.dataset';
import { FileFormat } from './file-format';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStoreGen2CosmosStructuredStream.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureDataLakeStoreGen2CosmosStructuredStream_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureDataLakeStoreGen2CosmosStructuredStream_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureDataLakeStoreGen2CosmosStructuredStreamLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureDataLakeStoreGen2CosmosStructuredStreamFileDataset extends FileTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly GENERATED_FROM_ACTIVITY: IAttribute;
    public static readonly FILE_SYSTEM: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_GeneratedFromActivity,
        association: 'GENERATED_FROM_ACTIVITY'
    })
    public generatedFromActivity?: boolean;

    @Metamodel.attribute({
        display: stringResources.FileSystem_DisplayText,
        association: 'FILE_SYSTEM',
        templatable: true,
        constraint: { 
            required: __IS_FABRIC_DPE__
        }
    })
    public fileSystem?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.format = new FileFormat();
        this.isV2 = true;
    }
}
